/**
 * Part of toolstool project.
 *
 * @copyright  Copyright (C) 2022 __ORGANIZATION__.
 * @license    __LICENSE__
 */

const moreBtn = $('.j-more');

moreBtn.on('click', (e) => {
  const $this = $(e.currentTarget);

  $this.closest('.c-filter').toggleClass('open');
  $this.closest('.j-btn-wrapper').find('.j-more').toggleClass('d-none');
});

const productFilter = $('.j-web-filter');

productFilter.each((i, e) => {
  let item = $(e);

  if (item.height() > 72) {
    item.find('.j-more').eq(0).removeClass('d-none');
  }

  item.addClass('hide');
});
